import script from "./TwNavigationLinkList.vue?vue&type=script&setup=true&lang=js"
export * from "./TwNavigationLinkList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__